import { render, staticRenderFns } from "./EmailInvitation.vue?vue&type=template&id=5bb6c180&scoped=true&"
import script from "./EmailInvitation.vue?vue&type=script&lang=js&"
export * from "./EmailInvitation.vue?vue&type=script&lang=js&"
import style0 from "./EmailInvitation.vue?vue&type=style&index=0&id=5bb6c180&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb6c180",
  null
  
)

export default component.exports